import React from 'react';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

function ProductDetailItemCard({ name, value }) {
	const { t } = useTranslation();
	return (
		<Grid
			item
			xs={12}
			role="paragraph"
			aria-label={t('product_details.product_details')}
		>
			<Typography
				variant="heading8"
				tabIndex={0}
				aria-label={name}
				role="paragraph"
			>
				{name}
			</Typography>

			<Grid item xs={6} mt={-0.35} role="paragraph" aria-label={value}>
				<Typography
					variant="caption1"
					tabIndex={0}
					aria-label={value}
					role="paragraph"
				>
					{value}
				</Typography>
			</Grid>
		</Grid>
	);
}

ProductDetailItemCard.propTypes = {
	name: PropTypes.string.isRequired,
	value: PropTypes.any,
};

export default ProductDetailItemCard;
